module.exports = __webpack_public_path__ + "static/img/celoscope-4.3c80127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-4.jpg
// module id = 9Nry
// module chunks = 52